// Side-effect import: registers job-sync integration data hooks (werkzoeken, indeed,
// cell renderers, row click handlers) with the central module registry.
import "../api";

import { useParams } from "react-router-dom";

import { VacancySyncOverviewHeader } from "../components/indeed/VacancySyncOverviewHeader";

import { ClientModuleDetailPage } from "@/features/integrations/modules/pages/ClientModuleDetailPage";
import { decodeSlug } from "@/features/integrations/utils/slug";

function JobSyncClientDetailPage() {
  const { integrationName } = useParams<{ integrationName?: string }>();
  const decoded = integrationName ? decodeSlug(integrationName) : "";
  const isIndeed = decoded.toLowerCase() === "indeed";

  return (
    <ClientModuleDetailPage
      moduleName="job-sync"
      moduleSubKey="jobSync"
      renderHeader={
        isIndeed
          ? ({ clientId, integrationName: backendIntegrationName }) => (
            <VacancySyncOverviewHeader
              clientId={clientId}
              integrationName={backendIntegrationName}
            />
          )
          : undefined
      }
    />
  );
}

export default JobSyncClientDetailPage;
